import { SecondOpinionWithRelations } from 'src/app/sdk-api';

export namespace SecondOpinionState {
  export const key = 'SecondOpinion';

  export interface State {
    secondOpinion: SecondOpinionWithRelations;
  }

  export const initialState: State = {
    secondOpinion: null,
  };
}
